// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"88821ec219e9d915","2959":"33c54bd7bbd63d61","4807":"ea1395692087c0ae"}[chunkId] + ".css";
};